let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8qRAy")).then(() => parcelRequire('eM952'));